var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.417 15L12.8813 10M8.11937 10L2.58369 15M2.16699 5.83337L8.97109 10.5962C9.52207 10.9819 9.79756 11.1748 10.0972 11.2495C10.3619 11.3154 10.6387 11.3154 10.9034 11.2495C11.2031 11.1748 11.4786 10.9819 12.0296 10.5962L18.8337 5.83337M6.16699 16.6667H14.8337C16.2338 16.6667 16.9339 16.6667 17.4686 16.3942C17.939 16.1545 18.3215 15.7721 18.5612 15.3017C18.8337 14.7669 18.8337 14.0668 18.8337 12.6667V7.33337C18.8337 5.93324 18.8337 5.23318 18.5612 4.6984C18.3215 4.22799 17.939 3.84554 17.4686 3.60586C16.9339 3.33337 16.2338 3.33337 14.8337 3.33337H6.16699C4.76686 3.33337 4.0668 3.33337 3.53202 3.60586C3.06161 3.84554 2.67916 4.22799 2.43948 4.6984C2.16699 5.23318 2.16699 5.93324 2.16699 7.33337V12.6667C2.16699 14.0668 2.16699 14.7669 2.43948 15.3017C2.67916 15.7721 3.06161 16.1545 3.53202 16.3942C4.0668 16.6667 4.76686 16.6667 6.16699 16.6667Z",
    stroke: "#3538CD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail02);
export default __webpack_public_path__ + "static/media/mail-02.ec3b85bf3bd58f9ada625f9a7b95798c.svg";
export { ForwardRef as ReactComponent };